/**
 * 店铺一览画面 - Action Types
 */

export const SET_SEARCH_PARAMS = 'shopList/SET_SEARCH_PARAMS';
export const SET_FILTERS = 'shopList/SET_FILTERS';
export const CLEAR_FILTERS = 'shopList/CLEAR_FILTERS';

export const GET_VISITOR_CLUB_OPTIONS_LIST_REQUEST = 'shoplist/GET_VISITOR_CLUB_OPTIONS_LIST_REQUEST' as const;
export const GET_VISITOR_CLUB_OPTIONS_LIST_SUCCESS = 'shoplist/GET_VISITOR_CLUB_OPTIONS_LIST_SUCCESS' as const;
export const GET_VISITOR_CLUB_OPTIONS_LIST_FAILURE = 'shoplist/GET_VISITOR_CLUB_OPTIONS_LIST_FAILURE' as const;
export const GET_VISITOR_CLUB_OPTIONS_LIST_INITIAL = 'shoplist/GET_VISITOR_CLUB_OPTIONS_LIST_INITIAL' as const;

export const GET_VISITOR_CLUB_LIST_REQUEST = 'shoplist/GET_VISITOR_CLUB_LIST_REQUEST' as const;
export const GET_VISITOR_CLUB_LIST_SUCCESS = 'shoplist/GET_VISITOR_CLUB_LIST_SUCCESS' as const;
export const GET_VISITOR_CLUB_LIST_FAILURE = 'shoplist/GET_VISITOR_CLUB_LIST_FAILURE' as const;
export const GET_VISITOR_CLUB_LIST_INITIAL = 'shoplist/GET_VISITOR_CLUB_LIST_INITIAL' as const;
